import React from 'react'
import PropTypes from 'prop-types'
import { isEmpty } from 'ramda'

import { useDispatch } from 'react-redux'
import { updateFragmentValue } from 'actions/powerTakeOff'

import { useSelector } from 'hooks/redux'
import {
  getGroupFragmentsWithBoundsFragments,
  getGroupBoundaries,
} from 'selectors/powerTakeOff'

import { extendSchema, yup } from 'schemas/validation'

import strings from 'utils/strings'

import Boundaries from './Boundaries'

import DynamicInput from '../DynamicInput'
import { StyledInputsWrapper, StyledParagraph } from './GroupEditor.style'

const GroupEditor = ({ groupId }) => {
  const dispatch = useDispatch()

  const { fragments, enables, enabledBy, lowerBound, upperBound } = useSelector(
    getGroupFragmentsWithBoundsFragments,
    {
      groupId,
    }
  )

  const groupBoundaries = useSelector(getGroupBoundaries, {
    lowerBound,
    upperBound,
  })

  const {
    upperBoundMin,
    lowerBoundMax,
    upperBoundFragments,
    lowerBoundFragments,
  } = groupBoundaries

  const showBoundaries = upperBoundMin || lowerBoundMax

  const renderFragments = (refIds) => {
    const inputs = refIds.map((refNo) => {
      const {
        name,
        configuration: {
          units,
          value,
          type,
          definedValues,
          translations,
          lowerBound: fragmentLowerBound,
          upperBound: fragmentUpperBound,
        },
        description,
        moduleNo,
      } = fragments[refNo]

      const handleChange = (newValue) =>
        dispatch(updateFragmentValue(refNo, newValue))

      const isValueFragment = fragmentLowerBound || fragmentUpperBound

      // if the fragment has bounds, then it is the 'value' fragment
      // and we must validate it is in the correct boundaries
      // investigate why using the 'schemaProp' pattern doesn't work here
      // *** Per task 42157 Turning off boundary validations until better design ***
      const rules = isValueFragment
        ? extendSchema(
            yup.mixed().includedIn('definedValues'),
            // .lessThanContext('upperBoundMin')
            // .moreThanContext('lowerBoundMax'),
            {
              definedValues,
              // lowerBoundMax,s
              // upperBoundMin,
            }
          )
        : extendSchema(yup.mixed().includedIn('definedValues'), {
            definedValues,
          })

      return (
        <DynamicInput
          disabled={isEmpty(definedValues)}
          refNo={refNo}
          key={refNo}
          name={name}
          units={units}
          value={value}
          description={description}
          moduleNo={moduleNo}
          type={type}
          definedValues={definedValues}
          translations={translations}
          onChange={handleChange}
          makeLabel={() => (units ? `${name} ${units}` : name)}
          rules={rules}
        />
      )
    })

    return <StyledInputsWrapper>{inputs}</StyledInputsWrapper>
  }

  if (!fragments) return null

  return (
    <>
      {renderFragments(enabledBy)}
      {renderFragments(enables)}

      {showBoundaries && (
        <>
          <StyledParagraph>
            {strings.fragment_value_explanation}
          </StyledParagraph>
          <Boundaries
            lowerBoundFragments={lowerBoundFragments}
            upperBoundFragments={upperBoundFragments}
          />
        </>
      )}
    </>
  )
}

GroupEditor.propTypes = {
  groupId: PropTypes.string,
}

export default GroupEditor
